import * as tz from 'date-fns-tz/fp';
import * as fns from 'date-fns/fp';

export { tz, fns };
